import { useEffect, useState } from "react";

export function useTableData({ endpoint }) {
  const [loading, setLoading] = useState(true);
  const [tableInfo, setTableInfo] = useState({});
  const [headerInfo, setHeaderInfo] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const onFilteredItemsChange = (data) => {
    setFilteredData(data);
  };

  useEffect(() => {
    async function fetchData() {
      const { data } = await endpoint();
      setLoading(false);
      setTableInfo(data.tableInfo);
      if (data.headerInfo) {
        setHeaderInfo(data.headerInfo);
      }
    }

    fetchData().catch((error) => {
      setLoading(false);
      console.log("Error while fetching list", error);
    });
  }, []);

  return { loading, tableInfo, setTableInfo, headerInfo, filteredData, onFilteredItemsChange };
}
